import { render } from "./toptombar.vue?vue&type=template&id=ff6cc90e"
import script from "./toptombar.vue?vue&type=script&lang=js"
export * from "./toptombar.vue?vue&type=script&lang=js"

import "./toptombar.vue?vue&type=style&index=0&id=ff6cc90e&lang=css"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__